export const Minus = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M30 15H0" stroke="#162BE6" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);
